"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOSIOAuth = void 0;
const universal_authenticator_library_1 = require("universal-authenticator-library");
const EOSIOAuthUser_1 = require("./EOSIOAuthUser");
const eosioLogo_1 = require("./eosioLogo");
const interfaces_1 = require("./interfaces");
const PlatformChecker_1 = require("./PlatformChecker");
const UALEOSIOAuthError_1 = require("./UALEOSIOAuthError");
class EOSIOAuth extends universal_authenticator_library_1.Authenticator {
    /**
     * EOSIO Reference Authenticator Constructor
     * @param chains
     * @param options
     */
    constructor(chains, options) {
        super(chains, options);
        this.users = [];
        this.eosioAuthIsLoading = false;
        this.initError = null;
        this.platformChecker = null;
        this.platformChecker = new PlatformChecker_1.PlatformChecker(this.options);
    }
    /**
     * Checks to see if EOSIO Reference Authenticator is available in the current environment.
     * Currently, the platformChecker only determines the presence
     * of the EOSIO Reference Chrome Extension Authenticator App.
     */
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.eosioAuthIsLoading = true;
            try {
                const isAvailable = yield this.platformChecker.isAvailable();
                if (!isAvailable) {
                    throw new Error('Unable to detect authenticator');
                }
            }
            catch (e) {
                const message = `Error occurred during initialization`;
                const type = universal_authenticator_library_1.UALErrorType.Initialization;
                const cause = e;
                this.initError = new UALEOSIOAuthError_1.UALEOSIOAuthError(message, type, cause);
            }
            finally {
                this.eosioAuthIsLoading = false;
            }
        });
    }
    reset() {
        this.initError = null;
        // tslint:disable-next-line:no-floating-promises
        this.init();
    }
    /**
     * EOSIO Reference Authenticator will render on mobile and desktop environments
     */
    shouldRender() {
        return this.platformChecker.isSupportedPlatform();
    }
    shouldAutoLogin() {
        return false; // EOSIO Reference Authenticator does not support autoLogin
    }
    shouldRequestAccountName() {
        return __awaiter(this, void 0, void 0, function* () {
            return true;
        });
    }
    login(accountName) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const chain of this.chains) {
                const user = yield new EOSIOAuthUser_1.EOSIOAuthUser(chain, accountName || '', this.options);
                yield user.init();
                const isValid = yield user.isAccountValid();
                if (!isValid) {
                    const message = `Error logging into account "${accountName}"`;
                    const type = universal_authenticator_library_1.UALErrorType.Login;
                    const cause = null;
                    throw new UALEOSIOAuthError_1.UALEOSIOAuthError(message, type, cause);
                }
                this.users.push(user);
            }
            return this.users;
        });
    }
    /**
     * Calls logout on EOSIO Reference Authenticator. This clears any key caching applied by the signature provider.
     * Throws a Logout Error if unsuccessful.
     */
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                for (const user of this.users) {
                    user.signatureProvider.cleanUp();
                    user.signatureProvider.clearCachedKeys();
                }
                this.users = [];
            }
            catch (e) {
                const message = `Error logging out`;
                const type = universal_authenticator_library_1.UALErrorType.Logout;
                const cause = e;
                throw new UALEOSIOAuthError_1.UALEOSIOAuthError(message, type, cause);
            }
        });
    }
    getStyle() {
        return {
            icon: eosioLogo_1.eosioLogo,
            text: interfaces_1.Name,
            textColor: 'white',
            background: '#1A3270',
        };
    }
    isLoading() {
        return this.eosioAuthIsLoading;
    }
    isErrored() {
        return !!this.initError;
    }
    getError() {
        return this.initError;
    }
    getOnboardingLink() {
        return 'https://github.com/EOSIO/ual-eosio-reference-authenticator';
    }
    requiresGetKeyConfirmation() {
        return false;
    }
    getName() {
        return interfaces_1.Name;
    }
}
exports.EOSIOAuth = EOSIOAuth;
